 // コードの実例を含む API レポートを参照するには https://wix.to/94BuAAs を開いてください。

$w.onReady(function () {
	//TODO: write your page related code here...

});